// extracted by mini-css-extract-plugin
export default {"handle":"use-resizable_handle__4WLon"};